import React from "react";
import { Link } from "react-router-dom";
import { FaGamepad, FaHeart, FaStar, FaSearch, FaUsers, FaDatabase } from "react-icons/fa";
import "../styles/About.css";

const About = () => {
  const features = [
    {
      icon: <FaGamepad />,
      title: "Extensive Game Database",
      description: "Access thousands of games with detailed information, ratings, and reviews from the gaming community."
    },
    {
      icon: <FaHeart />,
      title: "Personal Wishlist",
      description: "Save your favorite games and track what you want to play next with our personalized wishlist feature."
    },
    {
      icon: <FaStar />,
      title: "Community Reviews",
      description: "Read and write reviews, share your gaming experiences, and discover games through community feedback."
    },
    {
      icon: <FaSearch />,
      title: "Advanced Search & Filters",
      description: "Find exactly what you're looking for with our powerful search and filtering system by genre, platform, and more."
    },
    {
      icon: <FaUsers />,
      title: "User Profiles",
      description: "Create your gaming profile, track your reviews, and connect with other gamers in the community."
    },
    {
      icon: <FaDatabase />,
      title: "Real-time Data",
      description: "Get the latest game information, ratings, and community data updated in real-time."
    }
  ];

  const stats = [
    { number: "10,000+", label: "Games" },
    { number: "50,000+", label: "Reviews" },
    { number: "100,000+", label: "Users" },
    { number: "24/7", label: "Availability" }
  ];

  return (
    <div className="about-page">
      <div className="about-hero">
        <div className="hero-content">
          <h1>About <span className="brand-highlight">Beast</span></h1>
          <p className="hero-subtitle">
            Your ultimate destination for discovering, exploring, and sharing the world of gaming
          </p>
          <div className="hero-actions">
            <Link to="/" className="cta-button primary">
              Start Exploring
            </Link>
            <Link to="/trending" className="cta-button secondary">
              View Trending
            </Link>
          </div>
        </div>
        <div className="hero-visual">
          <div className="floating-games">
            <div className="floating-game-card" style={{ animationDelay: '0s' }}>
              <div className="game-placeholder">🎮</div>
            </div>
            <div className="floating-game-card" style={{ animationDelay: '1s' }}>
              <div className="game-placeholder">🏆</div>
            </div>
            <div className="floating-game-card" style={{ animationDelay: '2s' }}>
              <div className="game-placeholder">⭐</div>
            </div>
          </div>
        </div>
      </div>

      <section className="about-section">
        <h2>What is Beast?</h2>
        <p>
          Beast is a comprehensive gaming platform designed to help gamers discover new titles, 
          share their experiences, and build a community around their passion for gaming. 
          Whether you're a casual player or a hardcore enthusiast, Beast provides the tools 
          and information you need to make informed decisions about your next gaming adventure.
        </p>
      </section>

      <section className="features-section">
        <h2>Key Features</h2>
        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-card" style={{ animationDelay: `${index * 0.1}s` }}>
              <div className="feature-icon">{feature.icon}</div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="stats-section">
        <h2>Platform Statistics</h2>
        <div className="stats-grid">
          {stats.map((stat, index) => (
            <div key={index} className="stat-card">
              <div className="stat-number">{stat.number}</div>
              <div className="stat-label">{stat.label}</div>
            </div>
          ))}
        </div>
      </section>

      <section className="mission-section">
        <h2>Our Mission</h2>
        <div className="mission-content">
          <p>
            At Beast, we believe that gaming is more than just entertainment—it's a way to 
            connect, create, and explore new worlds. Our mission is to provide gamers with 
            a comprehensive platform that makes it easy to discover amazing games, share 
            experiences, and be part of a vibrant gaming community.
          </p>
          <p>
            We're committed to continuously improving our platform based on user feedback 
            and the evolving needs of the gaming community. Whether you're looking for your 
            next favorite game or want to share your thoughts with fellow gamers, Beast is 
            here to enhance your gaming journey.
          </p>
        </div>
      </section>

      <section className="cta-section">
        <h2>Ready to Start Your Gaming Journey?</h2>
        <p>Join thousands of gamers who are already using Beast to discover amazing games</p>
        <div className="cta-buttons">
          <Link to="/signup" className="cta-button primary large">
            Get Started
          </Link>
          <Link to="/" className="cta-button secondary large">
            Browse Games
          </Link>
        </div>
      </section>
    </div>
  );
};

export default About;
